import {
    ApiCadAdditionalInfo,
    ApiResultAdditionalInfosWithLinkedEventMap,
    ApiResultAdditionalInfoCreationResponse,
    V2Resource,
    NudgeObjectDto,
    BoloAdditionalInfo,
} from '@mark43/cad-api';

export type {
    AdditionalInfoNotificationManager,
    UnreadInfo,
} from './hooks/use-additional-infos/types';

export type AdditionalInfoView = ApiCadAdditionalInfo;

export type CreateAdditionalInfo = V2Resource.CreateAdditionalInfo1;

export interface AdditionalInfoFormView {
    agencyEventId: number;
    text: string;
    isHighPriority: boolean;
    isCrossClass: boolean;
}

export type CreateAdditionalInfoNext = V2Resource.CreateAdditionalInfoV21;
export type CreateAdditionainfoNextResponse = ApiResultAdditionalInfoCreationResponse;
export interface AdditionalInfoFormViewNext {
    agencyEventId: number;
    text: string;
    isHighPriority: boolean;
    crossClassOptions: number[];
    toExternalCadIntegrations: number[];
}

export enum AdditionalInfoType {
    USER = 'USER',
    SYSTEM = 'SYSTEM',
    PROQA = 'PRO_QA',
    PRO_QA_DESC_INFO = 'PRO_QA_DESC_INFO',
    PRO_QA_KEY_QUESTION = 'PRO_QA_KEY_QUESTION',
    PRO_QA_COMMENT = 'PRO_QA_COMMENT',
    PRO_QA_CRITICAL = 'PRO_QA_CRITICAL',
    PRO_QA_SCRIPT = 'PRO_QA_SCRIPT',
    PRO_QA_UPDATE = 'PRO_QA_UPDATE',
    PRO_QA_URGENT = 'PRO_QA_URGENT',
}

export enum Priority {
    STANDARD = 'STANDARD_UPDATE',
    HIGH = 'HIGH_PRIORITY_UPDATE',
}

export type DeleteAdditionalInfo = V2Resource.DeleteAdditionalInfo1;

export type GetAdditionalInfosByCursor = V2Resource.GetAdditionalInfosWithLinkedEventMap;

export type GetAdditionalInfosByIds = V2Resource.GetAdditionalInfosByIdsWithLinkedEventMap;

export type GetScheduledEventsAdditionalInfos =
    V2Resource.GetScheduledEventsAdditionalInfosWithLinkedEventMap;

export type ApiResultGetAdditionalInfosByCursor = ApiResultAdditionalInfosWithLinkedEventMap;

export type ApiResultGetScheduledEventInfosByCursor =
    V2Resource.GetScheduledEventsAdditionalInfosWithLinkedEventMap['returns'];

export type StreamMap = {
    nudge: NudgeObjectDto;
    infos: {
        reset?: number[];
        create?: (AdditionalInfoView & { text?: string })[];
        delete?: { agencyEventId: number; id: number }[];
    };

    boloAdditionalInfo: {
        boloId: number;
        boloLinkId: number;
        boloAdditionalInfo: BoloAdditionalInfo;
    };
};
